import DataSetResponseShowContainer from './data_set_response_show_container';

const DataSetResponseShow = DataSetResponseShowContainer;

export default DataSetResponseShow;
